import React from 'react';

import { Box, Typography } from '@mui/material';

import { ValueStub } from 'constants/data';
import { alwaysTrue } from 'utils/data';

import { deletedTextStyles } from './SlaGroupInfoModal.styles';
import { TaskSlaLevelColumnId, taskSlaTableWidthMap } from './TaskSlaGroupInfoModal.constants';
import TaskSlaLevelCell from './TaskSlaLevelCell';

const renderAssigneesCell = ({ value, deletedValue }) => (
  <Box>
    <Typography variant="regular16">{value || ValueStub.ALTERNATE}</Typography>
    {deletedValue && (
      <Typography component="p" sx={deletedTextStyles} variant="regular16">
        Deleted: {deletedValue}
      </Typography>
    )}
  </Box>
);

const getRowStyles = ({ _rowStyles }) => _rowStyles;

export const taskSlaTableConfig = {
  [TaskSlaLevelColumnId.LEVEL_NAME]: {
    label: 'SLA Level',
    width: taskSlaTableWidthMap[TaskSlaLevelColumnId.LEVEL_NAME],
    customStyles: getRowStyles,
    content: ({ _level }) => <TaskSlaLevelCell level={_level} />,
  },
  [TaskSlaLevelColumnId.SLA]: {
    label: 'SLA',
    width: taskSlaTableWidthMap[TaskSlaLevelColumnId.SLA],
    customStyles: getRowStyles,
    renderContentAsText: alwaysTrue,
    content: ({ [TaskSlaLevelColumnId.SLA]: cellData }) => cellData,
  },
  [TaskSlaLevelColumnId.POTENTIAL_ASSIGNEES]: {
    label: 'Potential Users',
    width: taskSlaTableWidthMap[TaskSlaLevelColumnId.POTENTIAL_ASSIGNEES],
    customStyles: getRowStyles,
    content: ({ [TaskSlaLevelColumnId.POTENTIAL_ASSIGNEES]: value, _deletedPotential }) =>
      renderAssigneesCell({ value, deletedValue: _deletedPotential }),
  },
  [TaskSlaLevelColumnId.ASSIGNED_USERS]: {
    label: 'Users to Complete',
    width: taskSlaTableWidthMap[TaskSlaLevelColumnId.ASSIGNED_USERS],
    customStyles: getRowStyles,
    content: ({ [TaskSlaLevelColumnId.ASSIGNED_USERS]: value, _deletedAssigned }) =>
      renderAssigneesCell({ value, deletedValue: _deletedAssigned }),
  },
  [TaskSlaLevelColumnId.ASSIGNMENT_TYPE]: {
    label: 'Assignment Type',
    width: taskSlaTableWidthMap[TaskSlaLevelColumnId.ASSIGNMENT_TYPE],
    customStyles: getRowStyles,
    renderContentAsText: alwaysTrue,
    content: ({ [TaskSlaLevelColumnId.ASSIGNMENT_TYPE]: cellData }) =>
      cellData || ValueStub.ALTERNATE,
  },
  [TaskSlaLevelColumnId.START_DATE]: {
    label: 'SLA Start Date/Time',
    width: taskSlaTableWidthMap[TaskSlaLevelColumnId.START_DATE],
    customStyles: getRowStyles,
    renderContentAsText: alwaysTrue,
    content: ({ [TaskSlaLevelColumnId.START_DATE]: cellData }) => cellData,
  },
};
